import type { HarEntry } from '@terra/shared-schemas-tracker';
import {
  mapHarEntryToHarRequest,
  type HARRequest,
} from './mapHarEntryToHarRequest';

export const getRequestDetailsHarState = ({
  selectedSlimRequest,
  selectedFullHar,
  isLoading,
  isError,
}: {
  selectedSlimRequest: HARRequest | null;
  selectedFullHar: HarEntry | null;
  isLoading: boolean;
  isError: boolean;
}): {
  selectedRequest: HARRequest | null;
  isLoadingFullHar: boolean;
  isFullHarError: boolean;
} => {
  if (!selectedSlimRequest) {
    return {
      selectedRequest: null,
      isLoadingFullHar: false,
      isFullHarError: false,
    };
  }

  const selectedRequest =
    selectedFullHar && selectedFullHar.id === selectedSlimRequest.id
      ? mapHarEntryToHarRequest(selectedFullHar)
      : null;

  if (selectedRequest) {
    return {
      selectedRequest,
      isLoadingFullHar: false,
      isFullHarError: false,
    };
  }

  if (isError && !isLoading) {
    return {
      selectedRequest: null,
      isLoadingFullHar: false,
      isFullHarError: true,
    };
  }

  return {
    selectedRequest: null,
    isLoadingFullHar: true,
    isFullHarError: false,
  };
};
